<div class="relative w-10 select-container" #selectContainer>
  <div class="flex items-center justify-center w-full cursor-pointer" (click)="toggleDropdown()">
    <i class="text-text-primary text-lg w-4 h-4 flex items-center justify-center" [ngClass]="icon"></i>
  </div>
  @if (isOpen()) {
  <div
    class="absolute z-50 mt-1 w-[327px] md:w-[440px] top-0 h-[304px] bg-white rounded-2xl animate-fadeIn flex flex-col"
    [ngClass]="dropdownPosition" [ngStyle]="dropdownStyles" [style.box-shadow]="'0px 8px 16px 0px #00000029'">
    <div class="flex items-center w-full my-2 px-2 flex-shrink-0">
      <i
        class="fi fi-rr-search absolute left-6 text-text-secondary leading-none pt-[1px] text-xl flex items-center justify-center"></i>
      <input type="text"
        class="w-full pl-12 pr-10 py-3 h-[40px] rounded-2xl border leading-none text-sm font-poppins font-medium border-soft-gray focus:outline-none placeholder:text-text-primary placeholder:font-normal"
        [placeholder]="placeholder" [(ngModel)]="searchTerm" />
      <i (click)="clearSearch()"
        class="fi fi-rr-x absolute cursor-pointer right-6 text-text-primary text-xs leading-none pt-[1px] flex items-center justify-center"></i>
    </div>
    <ul class="overflow-auto flex-1 px-2 pb-2">
      <li *ngFor="let option of filteredOptions; let i = index"
        class="px-4 py-2 text-sm text-gray-800 cursor-pointer"
        (click)="changeActiveForOption(option)">
        <app-checkbox id="checkbox-{{ option.value }}-{{ i }}" class="w-full pointer-events-none" [checked]="option.active"
          [parentController]="true">
          <p class="text-text-primary font-poppins font-normal text-sm disabled">
            {{ option.label }}
          </p>
        </app-checkbox>
      </li>

      <li *ngIf="filteredOptions.length === 0"
        class="px-4 py-2 text-text-primary font-poppins font-normal text-sm disabled">
        No hay resultados
      </li>
    </ul>
  </div>
  }
</div>